"use strict";
var distill;
(function (distill) {
    var datasets;
    (function (datasets) {
        var views;
        (function (views) {
            const PK_ALLOWED_TYPES = ['Text', 'Number', 'UniqueIdentifier'];
            let _columnIdCounter = 0;
            let _globalColumnTypes = [];
            let _isValidationRegistered = false;
            function registerDuplicateValidation() {
                if (_isValidationRegistered)
                    return;
                _isValidationRegistered = true;
                $.validator.addMethod('columnduplicate', function (value, element) {
                    const $allInputs = $('input.column-name:visible').filter(function () {
                        return !$(this).closest('tr').hasClass('column-row-excluded');
                    });
                    const currentVal = (value || '').trim().toLowerCase();
                    if (!currentVal)
                        return true;
                    let count = 0;
                    $allInputs.each(function () {
                        var _a, _b;
                        if (((_b = (_a = $(this).val()) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === currentVal)
                            count++;
                    });
                    return count <= 1;
                });
                $.validator.unobtrusive.adapters.addBool('columnduplicate');
            }
            function setColumnTypes(columnTypes) {
                _globalColumnTypes = columnTypes;
            }
            views.setColumnTypes = setColumnTypes;
            function getTypeLabel(typeName) {
                const found = _globalColumnTypes.find(ct => ct.value === typeName);
                return (found === null || found === void 0 ? void 0 : found.text) || typeName;
            }
            views.getTypeLabel = getTypeLabel;
            function generateColumnId() {
                _columnIdCounter++;
                return `col_${_columnIdCounter}_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
            }
            class ColumnBuilder {
                static refreshIndexes(builders) {
                    let currentIdx = 0;
                    builders.forEach(entry => {
                        if (!entry.builder)
                            return;
                        if (entry.skip)
                            entry.builder.updateFormColumnNames(-1);
                        else
                            currentIdx = entry.builder.updateFormColumnNames(currentIdx);
                    });
                    const $form = $('form');
                    if ($form.length && typeof $.validator.unobtrusive !== 'undefined') {
                        $form.removeData("validator").removeData("unobtrusiveValidation");
                        $.validator.unobtrusive.parse($form);
                    }
                }
                constructor(initialColumns, config) {
                    registerDuplicateValidation();
                    this._columns = initialColumns || [];
                    this._config = this.mergeConfig(config);
                    this._containerId = this._config.containerId || 'schemaColumnsList';
                    this._newColumnIds = new Set();
                    this._columnIdsInUse = new Set(this._config.columnIdsInUse || []);
                    const $tbody = $(`#${this._containerId} tbody`);
                    if ($tbody.length && $tbody.children('tr').length === 0)
                        this._columns.forEach((col, idx) => this.renderColumnRow(col, idx, false));
                    else if ($tbody.length && $tbody.children('tr').length > 0) {
                        this.updateFormColumnNames();
                        $(`#${this._containerId} tbody tr[data-is-new="true"]`).each((_, row) => {
                            const columnId = $(row).attr('data-column-id');
                            if (columnId)
                                this._newColumnIds.add(columnId);
                        });
                        setTimeout(() => {
                            $(`#${this._containerId} tbody tr`).each((_, row) => {
                                const $row = $(row);
                                const isPk = $row.attr('data-is-pk') === 'true';
                                this.updateTypeOptions($row, isPk, true);
                            });
                            appn.select.init({
                                selector: `#${this._containerId} tbody .select2-noinit`,
                                minimumResultsForSearch: 'Infinity',
                                omitWidth: false
                            });
                        }, 0);
                    }
                    this.bindTableEvents();
                }
                mergeConfig(config) {
                    return {
                        isCruxSource: (config === null || config === void 0 ? void 0 : config.isCruxSource) === true,
                        isCreateMode: (config === null || config === void 0 ? void 0 : config.isCreateMode) === true,
                        containerId: (config === null || config === void 0 ? void 0 : config.containerId) || 'schemaColumnsList',
                        showPk: (config === null || config === void 0 ? void 0 : config.showPk) !== false,
                        showType: (config === null || config === void 0 ? void 0 : config.showType) !== false,
                        showRequired: (config === null || config === void 0 ? void 0 : config.showRequired) !== false,
                        showUnique: (config === null || config === void 0 ? void 0 : config.showUnique) !== false,
                        showDefaultValue: (config === null || config === void 0 ? void 0 : config.showDefaultValue) !== false,
                        allowTypeChanges: (config === null || config === void 0 ? void 0 : config.allowTypeChanges) !== false,
                        hideCruxAutoColumnProperties: (config === null || config === void 0 ? void 0 : config.hideCruxAutoColumnProperties) === true,
                        readonlyRequiredUnique: (config === null || config === void 0 ? void 0 : config.readonlyRequiredUnique) === true,
                        originalPrimaryKeyIds: (config === null || config === void 0 ? void 0 : config.originalPrimaryKeyIds) || [],
                        orphanedColumnIds: (config === null || config === void 0 ? void 0 : config.orphanedColumnIds) || []
                    };
                }
                get columns() { return this._columns; }
                setColumns(columns) {
                    this._columns = columns || [];
                    this._newColumnIds.clear();
                    $(`#${this._containerId} tbody`).empty();
                    this._columns.forEach((col, idx) => this.renderColumnRow(col, idx, false));
                    this.updateFormColumnNames();
                    setTimeout(() => {
                        $(`#${this._containerId} tbody tr`).each((_, row) => {
                            const $row = $(row);
                            const isPk = $row.attr('data-is-pk') === 'true';
                            this.updateTypeOptions($row, isPk, true);
                        });
                        appn.select.init({
                            selector: `#${this._containerId} tbody .select2-noinit`,
                            minimumResultsForSearch: 'Infinity',
                            omitWidth: false
                        });
                    }, 0);
                }
                addColumn() {
                    const newColumn = {
                        id: generateColumnId(),
                        displayName: '',
                        type: 'UniqueIdentifier',
                        required: false,
                        unique: false,
                        defaultValue: '',
                        isPrimaryKey: false,
                        displayOrder: 0,
                        isExcluded: false,
                        isNew: true
                    };
                    const rowLastUpdatedIdx = this._columns.findIndex(c => c.designation === 'RowLastUpdated');
                    if (rowLastUpdatedIdx > -1)
                        this._columns.splice(rowLastUpdatedIdx, 0, newColumn);
                    else
                        this._columns.push(newColumn);
                    this._newColumnIds.add(newColumn.id);
                    const newIdx = this._columns.indexOf(newColumn);
                    this.renderColumnRow(newColumn, newIdx, true);
                    this.updateFormColumnNames();
                    if (this._config.onChanged)
                        this._config.onChanged();
                    setTimeout(() => {
                        const $row = $(`#${this._containerId} tbody tr[data-column-id="${newColumn.id}"]`);
                        if ($row.length) {
                            this.updateTypeOptions($row, newColumn.isPrimaryKey, true);
                            appn.select.init({
                                selector: `#${this._containerId} tbody tr[data-column-id="${newColumn.id}"] .select2-noinit`,
                                minimumResultsForSearch: 'Infinity',
                                omitWidth: false
                            });
                        }
                    }, 0);
                }
                addIncludeCruxColumns(columns) {
                    if (!this._config.isCruxSource || !columns || columns.length === 0)
                        return;
                    columns.sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
                    columns.forEach(col => {
                        col.id = col.id || generateColumnId();
                        col.isNew = true;
                        col.isPrimaryKey = false;
                        this._newColumnIds.add(col.id);
                        let insertIndex = -1;
                        for (let i = 0; i < this._columns.length; i++) {
                            const current = this._columns[i];
                            if (current.designation === 'RowLastUpdated') {
                                insertIndex = i;
                                break;
                            }
                            if ((current.displayOrder || 0) > (col.displayOrder || 0)) {
                                insertIndex = i;
                                break;
                            }
                        }
                        if (insertIndex === -1) {
                            const rowLastUpdatedIdx = this._columns.findIndex(c => c.designation === 'RowLastUpdated');
                            insertIndex = rowLastUpdatedIdx > -1 ? rowLastUpdatedIdx : this._columns.length;
                        }
                        this._columns.splice(insertIndex, 0, col);
                        this.renderColumnRow(col, insertIndex, true);
                        setTimeout(() => {
                            appn.select.init({
                                selector: `#${this._containerId} tbody tr[data-column-id="${col.id}"] .select2-noinit`,
                                minimumResultsForSearch: 'Infinity',
                                omitWidth: false
                            });
                        }, 0);
                    });
                    this.updateFormColumnNames();
                    if (this._config.onChanged)
                        this._config.onChanged();
                }
                deleteColumn(columnId) {
                    if (!this._newColumnIds.has(columnId))
                        return;
                    this._columns = this._columns.filter(c => c.id !== columnId);
                    this._newColumnIds.delete(columnId);
                    $(`#${this._containerId} tbody tr[data-column-id="${columnId}"]`).remove();
                    this.updateFormColumnNames();
                    if (this._config.onChanged)
                        this._config.onChanged();
                }
                toggleColumnExclusion(columnId) {
                    if (this._newColumnIds.has(columnId))
                        return;
                    const column = this._columns.find(c => c.id === columnId);
                    if (!column || column.alwaysIncluded || column.isPrimaryKey)
                        return;
                    column.isExcluded = !column.isExcluded;
                    const $row = $(`#${this._containerId} tbody tr[data-column-id="${columnId}"]`);
                    if ($row.length > 0) {
                        if (column.isExcluded)
                            $row.addClass('column-row-excluded');
                        else
                            $row.removeClass('column-row-excluded');
                        this.updateRowVisuals(column, $row);
                    }
                    this.updateFormColumnNames();
                    if (this._config.onChanged)
                        this._config.onChanged();
                }
                updateRowVisuals(column, $row) {
                    const hasDesignation = column.designation;
                    const isGeoColumn = hasDesignation && ['GeoLat', 'GeoLon', 'GeoHdg', 'GeoAlt', 'GeoAcc'].includes(column.designation);
                    const isTimeColumn = hasDesignation && ['EntryStartTime', 'EntryCompleteTime', 'EntryReceivedTime', 'RowLastUpdated'].includes(column.designation);
                    const isForeignKey = hasDesignation && ['RepeatId', 'EntryId'].includes(column.designation);
                    const $iconPk = $row.find('.icon-pk').addClass('d-none');
                    const $iconTime = $row.find('.icon-time').addClass('d-none');
                    const $iconForeignKey = $row.find('.icon-foreign-key').addClass('d-none');
                    const $iconGeo = $row.find('.icon-geo').addClass('d-none');
                    const $iconSystem = $row.find('.icon-system').addClass('d-none');
                    const $iconOrphaned = $row.find('.icon-orphaned').addClass('d-none');
                    if (column.isOrphaned && !column.isExcluded)
                        $iconOrphaned.removeClass('d-none');
                    else if (column.isPrimaryKey)
                        $iconPk.removeClass('d-none');
                    else if (isGeoColumn)
                        $iconGeo.removeClass('d-none');
                    else if (isTimeColumn)
                        $iconTime.removeClass('d-none');
                    else if (isForeignKey)
                        $iconForeignKey.removeClass('d-none');
                    else if (hasDesignation)
                        $iconSystem.removeClass('d-none');
                    const $iconLock = $row.find('.icon-lock').addClass('d-none');
                    const $iconInUseLock = $row.find('.icon-inuse-lock').addClass('d-none');
                    const $btnDelete = $row.find('.delete-column-btn').addClass('d-none');
                    const $btnInclude = $row.find('.include-column-btn').addClass('d-none');
                    const $btnExclude = $row.find('.exclude-column-btn').addClass('d-none');
                    const isInUse = this._columnIdsInUse.has(column.id);
                    if (column.alwaysIncluded || column.isPrimaryKey)
                        $iconLock.removeClass('d-none');
                    else if (isInUse)
                        $iconInUseLock.removeClass('d-none');
                    else if (column.isNew)
                        $btnDelete.removeClass('d-none');
                    else {
                        if (column.isExcluded)
                            $btnInclude.removeClass('d-none');
                        else
                            $btnExclude.removeClass('d-none');
                    }
                }
                updateFormColumnNames(baseIndex = 0) {
                    const $rows = $(`#${this._containerId} tbody tr[data-column-id]`);
                    let colIdx = baseIndex;
                    $rows.each((_, row) => {
                        var _a, _b, _c;
                        const $row = $(row);
                        const columnId = ((_a = $row.data('column-id')) === null || _a === void 0 ? void 0 : _a.toString()) || '';
                        const column = this._columns.find(c => c.id === columnId);
                        const isExcluded = (column === null || column === void 0 ? void 0 : column.isExcluded) === true || baseIndex === -1;
                        if (isExcluded) {
                            $row.find('input, select').each(function () {
                                if ($(this).attr('name')) {
                                    $(this).attr('data-original-name', $(this).attr('name') || '');
                                }
                                $(this).removeAttr('name').removeAttr('id');
                            });
                            $row.find('[data-val="true"]').attr('data-val', 'false');
                            return;
                        }
                        const assign = ($el, prop, validate = false) => {
                            if ($el.length === 0)
                                return;
                            const name = `Columns[${colIdx}].${prop}`;
                            const id = `Columns_${colIdx}__${prop}`;
                            $el.attr('name', name).attr('id', id);
                            $el.attr('data-val', validate ? 'true' : 'false');
                        };
                        $row.find('input[data-prop], select[data-prop]')
                            .removeAttr('name').removeAttr('id')
                            .attr('data-val', 'false');
                        assign($row.find('.column-id'), 'Id');
                        assign($row.find('.column-display-order'), 'DisplayOrder');
                        assign($row.find('.column-designation'), 'Designation');
                        assign($row.find('.column-original-header'), 'OriginalFileHeader');
                        assign($row.find('.column-field-name'), 'FieldName');
                        assign($row.find('.column-repeat-name'), 'CruxRepeatName');
                        assign($row.find('.column-category'), 'ColumnCategory');
                        assign($row.find('.column-always-included'), 'AlwaysIncluded');
                        assign($row.find('.column-name'), 'DisplayName', true);
                        const $pkCheck = $row.find('.column-pk');
                        const $pkHidden = $row.find('.column-pk-hidden');
                        if ($pkCheck.length > 0) {
                            $pkHidden.val($pkCheck.is(':checked') ? 'true' : 'false');
                        }
                        assign($pkHidden, 'IsPrimaryKey');
                        const $reqCheck = $row.find('.column-required');
                        const $reqHidden = $row.find('.column-required-hidden');
                        if ($reqCheck.length > 0) {
                            $reqHidden.val($reqCheck.is(':checked') ? 'true' : 'false');
                        }
                        assign($reqHidden, 'Required');
                        const $uniCheck = $row.find('.column-unique');
                        const $uniHidden = $row.find('.column-unique-hidden');
                        if ($uniCheck.length > 0) {
                            $uniHidden.val($uniCheck.is(':checked') ? 'true' : 'false');
                        }
                        assign($uniHidden, 'Unique');
                        const $typeSelect = $row.find('.column-type');
                        const $typeHidden = $row.find('.column-type-hidden');
                        if ($typeSelect.length > 0 && !$typeSelect.is(':disabled')) {
                            assign($typeSelect, 'Type', true);
                            $typeHidden.val(((_b = $typeSelect.val()) === null || _b === void 0 ? void 0 : _b.toString()) || 'Text');
                        }
                        else {
                            assign($typeHidden, 'Type');
                        }
                        const $defaultInput = $row.find('.column-default');
                        const $defaultHidden = $row.find('.column-default-hidden');
                        if ($defaultInput.length > 0 && !$defaultInput.is(':disabled')) {
                            assign($defaultInput, 'DefaultValue');
                            $defaultHidden.val(((_c = $defaultInput.val()) === null || _c === void 0 ? void 0 : _c.toString()) || '');
                        }
                        else {
                            assign($defaultHidden, 'DefaultValue');
                        }
                        $row.find('[data-valmsg-for-prop]').each(function () {
                            const prop = $(this).data('valmsg-for-prop');
                            $(this).attr('data-valmsg-for', `Columns[${colIdx}].${prop}`);
                        });
                        if (!this._config.isCruxSource) {
                            $row.find('.column-display-order').val(colIdx + 1);
                            if (column)
                                column.displayOrder = colIdx + 1;
                        }
                        $row.find('label[for]').each(function () {
                            const currentFor = $(this).attr('for') || '';
                            if (currentFor.includes('[') || currentFor.includes('.')) {
                                const safeFor = currentFor.replace(/\[/g, '_').replace(/\]/g, '_').replace(/\./g, '_');
                                $(this).attr('for', safeFor);
                            }
                        });
                        $row.find('input, select').attr('autocomplete', 'off');
                        colIdx++;
                    });
                    return colIdx;
                }
                renderColumnRow(column, index, isNew) {
                    var _a;
                    const isExcluded = column.isExcluded === true;
                    const isOriginalPk = ((_a = this._config.originalPrimaryKeyIds) === null || _a === void 0 ? void 0 : _a.includes(column.id)) || false;
                    const isOrphaned = column.isOrphaned === true;
                    const hasDesignation = !!column.designation;
                    const isAuto = column.columnCategory === 'auto' || hasDesignation;
                    const isSingular = column.columnCategory === 'singular' || !isAuto;
                    const disableSingularPk = isSingular && this._config.isCruxSource;
                    const tokens = {
                        id: column.id || '',
                        fieldName: column.fieldName || column.displayName || '',
                        displayName: column.displayName || '',
                        originalFileHeader: column.originalFileHeader || '',
                        displayOrder: (column.displayOrder || 0).toString(),
                        type: column.type || 'Text',
                        designation: column.designation || '',
                        designationStr: column.designation || '',
                        cruxRepeatName: column.cruxRepeatName || '',
                        columnCategory: column.columnCategory || '',
                        alwaysIncluded: (column.alwaysIncluded || false).toString().toLowerCase(),
                        isPkStr: (column.isPrimaryKey || false).toString().toLowerCase(),
                        isPk: (column.isPrimaryKey || false).toString().toLowerCase(),
                        requiredStr: (column.required || false).toString().toLowerCase(),
                        uniqueStr: (column.unique || false).toString().toLowerCase(),
                        defaultValue: column.defaultValue || '',
                        isNew: (column.isNew || false).toString().toLowerCase(),
                        isExcluded: isExcluded.toString().toLowerCase(),
                        isOrphaned: isOrphaned.toString().toLowerCase(),
                        excludedClass: isExcluded ? 'column-row-excluded' : '',
                        isNewClass: column.isNew ? 'column-row-new' : '',
                        orphanedClass: isOrphaned ? 'column-row-orphaned' : '',
                        namereadonly: (isAuto || column.alwaysIncluded) ? 'readonly tabindex="-1"' : '',
                        pkdisabled: (disableSingularPk || isAuto || column.alwaysIncluded || !this._config.isCreateMode) ? 'disabled' : '',
                        requireddisabled: (isAuto || isOriginalPk || column.isPrimaryKey || column.alwaysIncluded || this._config.readonlyRequiredUnique) ? 'disabled' : '',
                        uniquedisabled: (isAuto || isOriginalPk || column.alwaysIncluded || this._config.readonlyRequiredUnique) ? 'disabled' : '',
                        defaultdisabled: (isAuto || isOriginalPk || column.alwaysIncluded || column.isPrimaryKey) ? 'disabled' : '',
                        typedisabled: (isAuto || isOriginalPk || column.alwaysIncluded || (this._config.isCruxSource && !this._config.isCreateMode && !column.isNew)) ? 'disabled' : '',
                        pkchecked: column.isPrimaryKey ? 'checked' : '',
                        requiredchecked: column.required ? 'checked' : '',
                        uniquechecked: column.unique ? 'checked' : '',
                        typename: (isAuto || isOriginalPk || column.alwaysIncluded || (this._config.isCruxSource && !this._config.isCreateMode && !column.isNew)) ? '' : `name="Columns[${index}].Type"`,
                        typeOptions: this.buildTypeOptions(column),
                        idx: index.toString()
                    };
                    const template = document.getElementById('tpl-column-builder-row');
                    let html = (template === null || template === void 0 ? void 0 : template.innerHTML) || '';
                    for (const [key, value] of Object.entries(tokens)) {
                        const regex = new RegExp(`{${key}}`, 'g');
                        html = html.replace(regex, value);
                    }
                    const $row = $(html);
                    this.updateRowVisuals(column, $row);
                    if (isNew) {
                        const $rows = $(`#${this._containerId} tbody tr`);
                        if (index < $rows.length)
                            $rows.eq(index).before($row);
                        else
                            $(`#${this._containerId} tbody`).append($row);
                    }
                    else {
                        $(`#${this._containerId} tbody`).append($row);
                    }
                }
                buildTypeOptions(column) {
                    let options = '';
                    for (const ct of _globalColumnTypes) {
                        const selected = ct.value === column.type ? 'selected' : '';
                        options += `<option value="${ct.value}" ${selected}>${ct.text}</option>`;
                    }
                    return options;
                }
                updateTypeOptions($row, isPk, isInitial = false) {
                    var _a;
                    const $select = $row.find('.column-type');
                    if ($select.length === 0 || $select.is(':disabled'))
                        return;
                    const currentVal = ((_a = $select.val()) === null || _a === void 0 ? void 0 : _a.toString()) || '';
                    if (isPk) {
                        if (!$select.attr('data-pre-pk-type')) {
                            $select.attr('data-pre-pk-type', currentVal);
                        }
                        $select.find('option').each(function () {
                            const val = $(this).val();
                            if (PK_ALLOWED_TYPES.indexOf(val) === -1) {
                                $(this).prop('disabled', true).hide();
                            }
                            else {
                                $(this).prop('disabled', false).show();
                            }
                        });
                        if (PK_ALLOWED_TYPES.indexOf(currentVal) === -1) {
                            $select.val('').trigger('change.select2');
                        }
                    }
                    else {
                        $select.find('option').prop('disabled', false).show();
                        if (!isInitial) {
                            const prePkType = $select.attr('data-pre-pk-type');
                            if (prePkType) {
                                $select.val(prePkType).trigger('change.select2');
                                $select.removeAttr('data-pre-pk-type');
                            }
                        }
                    }
                }
                bindTableEvents() {
                    const $table = $(`#${this._containerId}`);
                    $table.off('.columnBuilder').on('input.columnBuilder', '.column-name', (e) => {
                        var _a;
                        const columnId = $(e.currentTarget).data('column-id');
                        const column = this._columns.find(c => c.id === columnId);
                        if (column)
                            column.displayName = ((_a = $(e.currentTarget).val()) === null || _a === void 0 ? void 0 : _a.toString()) || '';
                    })
                        .on('change.columnBuilder', '.column-pk', (e) => {
                        var _a;
                        const columnId = $(e.currentTarget).data('column-id');
                        const column = this._columns.find(c => c.id === columnId);
                        if (column) {
                            const isChecked = $(e.currentTarget).is(':checked');
                            column.isPrimaryKey = isChecked;
                            const $row = $(e.currentTarget).closest('tr');
                            $row.find('.column-pk-hidden').val(isChecked.toString().toLowerCase());
                            $row.attr('data-is-pk', isChecked.toString().toLowerCase());
                            if (isChecked) {
                                column.required = true;
                                $row.find('.column-required').prop('checked', true).prop('disabled', true);
                                $row.find('.column-required-hidden').val('true');
                            }
                            else {
                                const isOriginalPk = ((_a = this._config.originalPrimaryKeyIds) === null || _a === void 0 ? void 0 : _a.includes(column.id)) || false;
                                const reqDisabled = column.designation != null || isOriginalPk || column.alwaysIncluded || this._config.readonlyRequiredUnique;
                                $row.find('.column-required').prop('disabled', reqDisabled);
                            }
                            this.updateTypeOptions($row, isChecked);
                            this.updateRowVisuals(column, $row);
                        }
                    })
                        .on('input.columnBuilder', '.column-default', (e) => {
                        var _a;
                        const columnId = $(e.currentTarget).data('column-id');
                        const column = this._columns.find(c => c.id === columnId);
                        if (column)
                            column.defaultValue = ((_a = $(e.currentTarget).val()) === null || _a === void 0 ? void 0 : _a.toString()) || '';
                    })
                        .on('change.columnBuilder', '.column-type', (e) => {
                        var _a;
                        const columnId = $(e.currentTarget).data('column-id');
                        const column = this._columns.find(c => c.id === columnId);
                        if (column) {
                            column.type = ((_a = $(e.currentTarget).val()) === null || _a === void 0 ? void 0 : _a.toString()) || 'Text';
                            const $hidden = $(e.currentTarget).closest('tr').find('.column-type-hidden');
                            if ($hidden.length)
                                $hidden.val(column.type);
                        }
                    })
                        .on('change.columnBuilder', '.column-required', (e) => {
                        const columnId = $(e.currentTarget).data('column-id');
                        const column = this._columns.find(c => c.id === columnId);
                        if (column) {
                            column.required = $(e.currentTarget).is(':checked');
                            $(e.currentTarget).closest('tr').find('.column-required-hidden').val(column.required.toString());
                        }
                    })
                        .on('change.columnBuilder', '.column-unique', (e) => {
                        const columnId = $(e.currentTarget).data('column-id');
                        const column = this._columns.find(c => c.id === columnId);
                        if (column) {
                            column.unique = $(e.currentTarget).is(':checked');
                            $(e.currentTarget).closest('tr').find('.column-unique-hidden').val(column.unique.toString());
                        }
                    })
                        .on('click.columnBuilder', '.delete-column-btn', (e) => {
                        e.preventDefault();
                        const columnId = $(e.currentTarget).data('column-id');
                        this.deleteColumn(columnId);
                    })
                        .on('click.columnBuilder', '.exclude-column-btn, .include-column-btn', (e) => {
                        e.preventDefault();
                        const columnId = $(e.currentTarget).data('column-id');
                        this.toggleColumnExclusion(columnId);
                    });
                }
            }
            views.ColumnBuilder = ColumnBuilder;
        })(views = datasets.views || (datasets.views = {}));
    })(datasets = distill.datasets || (distill.datasets = {}));
})(distill || (distill = {}));
